
export class Member{
    id: string="";
    email_address: string;
    status:string;
}